import { render, staticRenderFns } from "./MessageResultArchiveDetails.vue?vue&type=template&id=005757df"
import script from "./MessageResultArchiveDetails.vue?vue&type=script&lang=js"
export * from "./MessageResultArchiveDetails.vue?vue&type=script&lang=js"
import style0 from "./MessageResultArchiveDetails.vue?vue&type=style&index=0&id=005757df&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports